import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import DialogueNote from "../../dialogue-note/DialogueNote";
import CustomerDialogueWrapper from "./CustomerDialogueWrapper";
import CustomerDialogueBody from "./CustomerDialogueBody";
const useStyles = makeStyles({
  dialogueWrapper: {
    display: "flex"
  },
  dialogueNote: {
    display: "flex",
    width: "25%",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  }
});
const CustomerDialogue = ({
  dialogue,
  shouldAnimate
}) => {
  const classes = useStyles();
  const {
    body,
    contentModerated
  } = dialogue;
  const isRtl = document.documentElement.getAttribute("dir") === "rtl";
  const hasDialogueNote = contentModerated && contentModerated.reason ? true : false;
  return /*#__PURE__*/React.createElement(CustomerDialogueWrapper, {
    dialogue: dialogue,
    shouldAnimate: shouldAnimate
  }, () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.dialogueWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.dialogueNote
    }, hasDialogueNote && /*#__PURE__*/React.createElement(DialogueNote, {
      note: contentModerated
    })), /*#__PURE__*/React.createElement(CustomerDialogueBody, {
      body: body,
      isRtl: isRtl
    }));
  });
};
export default CustomerDialogue;
CustomerDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired
};